export default "__VITE_ASSET__ChmXrnSf__"